import React from 'react';

import AppLayout from './AppLayout';

const Layouts = {
  EMPTY: props => <>{props.children}</>,
  APP_LAYOUT: AppLayout,
};

export default Layouts;
